export default __webpack_public_path__ + "static/media/CEAImg.53eded61.png";